import { Injectable, inject, DOCUMENT } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppRouterService } from '../app-router.service';
import { ScriptLoaderService } from '../sys/script-loader.service';

interface WisepopsWindow extends Window {
  wisepops?: (event?: string) => void;
}

@Injectable({
  providedIn: 'root',
})
export class PromoService {
  private readonly _appRouter: AppRouterService = inject(AppRouterService);
  private readonly _scriptLoader: ScriptLoaderService =
    inject(ScriptLoaderService);
  private readonly _document: Document = inject<Document>(DOCUMENT);

  public bootstrap(): void {
    if (environment.wisepopsScript) {
      this._scriptLoader
        .load(environment.wisepopsScript)
        .subscribe((script?: HTMLScriptElement) => {
          this._appRouter.navigationEnd$.subscribe(() => {
            if (this.window.wisepops) {
              this.window.wisepops('pageview');
            }
          });
        });
    }
  }

  private get window(): WisepopsWindow {
    return this._document.defaultView as WisepopsWindow;
  }
}
